<!--TITLE-->
<div class="container-fluid pt-120 pb-5">
    <div class="row title-bar">
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h1 class="text-uppercase text-center"><span class="text-red">Heat</span> Pumps</h1>
                        <p class="text-center pt-3">Eazy Breezy prides ourselves on being <span class="text-bold">Heat Pump specialists</span>. With this new technology, we have invested many hours into training and research to ensure we are able to provide our customers with answers to their questions.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--HEATPUMP BAR-->
<div class="container-fluid">
    <div class="container heatpump-container">
        <div class="row heatpump-bar bg-blue">
            <div class="col-sm-6">
                <h2 class="text-white text-center text-uppercase pt-5">Learn How Efficient A Heat Pump Can Be, Even In Below Zero Temperatures.</h2>
                <!--<div class="pt-4 text-center d-flex justify-content-center authorized-logo">
                    <img src="../../../assets/company-logos/colemanauth-white.png" alt="Coleman Authorized Dealer - Heating &amp; Cooling">
                </div>-->
            </div>
            <div class="col-sm-6 d-flex justify-content-center">
                <img src="../../../assets/site-theme/heatpump.png" alt="Heat Pump">
            </div>
        </div>
    </div>
</div>

<!--CONTENT-->
<div class="container-fluid pt-5">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h1>Heat Pump Basic Concepts</h1>
                <p class="pt-3">A heat pump is an electrically driven device that extracts heat from a low temperature place (a <span class=”text-bold”>source</span>), and delivers it to a higher temperature place (a <span class=”text-bold”>sink</span>).</p>
                <p class="pt-3">To understand this process, think about a bicycle ride over a hill: No effort is required to go from the top of the hill to the bottom, as the bike and rider will move naturally from a high place to a lower one. However, going up the hill requires a lot more work, as the bike is moving against the natural direction of motion.</p>
                <p class="pt-3">In a similar manner, heat naturally flows from places with higher temperature to locations with lower temperatures (e.g., in the winter, heat from inside the building is lost to the outside). A heat pump uses additional electrical energy to counter the natural flow of heat, and <span class=”text-italic”>pump</span> the energy available in a colder place to a warmer one.</p>
                <p class="pt-3">So how does a heat pump heat or cool your home? As energy is extracted from a <span class=”text-bold”>source</span>, the temperature of the source is reduced. If the home is used as the source, thermal energy will be removed, <span class=”text-italic”>cooling</span> this space. This is how a heat pump operates in cooling mode, and is the same principle used by air conditioners and refrigerators. Similarly, as energy is added to a <span class=”text-bold”>sink</span>, it’s temperature increases. If the home is used as a sink, thermal energy will be added, heating the space. A heat pump is fully reversible, meaning that it can both heat and cool your home, providing year-round comfort.</p>
                <p><a href="https://natural-resources.canada.ca/energy-efficiency/energy-star-canada/about/energy-star-announcements/publications/heating-and-cooling-heat-pump/6817#b" class="text-blue">Source Information</a></p>
            </div>
            <!--TAKEN OUT AT CLIENT'S REQUEST DUE TO GOVERNMENT NO LONGER OFFERING GRANTS <div class="col-sm-4 grant-container nopadding">
                <div class="p-3 text-center">
                    <img src="../../../assets/company-logos/icon-sprite-moneybag-yellow.png">
                    <h2 class="text-yellow text-center text-uppercase">Grants</h2>
                    <p class="text-yellow text-center pt-3 pb-3">Right now, the Government of Canada is offering home owners grants to make your house more energy efficient.</p>
                </div>
                <p class="text-white text-center text-bold bg-yellow p-3">Let Eazy Breezy Heating & Cooling help guide you through this process. We will be able to supply you with information on the grant process and pre-retrofit/ post-retrofit Energuide evaluations.</p>
                <div class="row pt-2 pl-1">
                    <div class="col-sm-2 pr-0 d-flex justify-content-center">
                        <img src="../../../assets/company-logos/icon-sprite-checkcircle-yellow.png" class="mt-3">
                    </div>
                    <div class="col-sm-10 mobile-text-center">
                        <h3 class="text-yellow text-bold">From $125 to $5,000</h3>
                        <p class="text-yellow">To get back a portion of your costs for eligible home retrofits.</p>
                    </div>
                </div>
                <div class="row pt-2 pl-1 pr-1">
                    <div class="col-sm-2 pr-0 d-flex justify-content-center">
                        <img src="../../../assets/company-logos/icon-sprite-checkcircle-yellow.png" class="mt-3">
                    </div>
                    <div class="col-sm-10 mobile-text-center">
                        <h3 class="text-yellow text-bold">From $5,000 to $40,000</h3>
                        <p class="text-yellow">Interest free loans with a repayment term of 10 years to help you undertake major home retrofits.</p>
                    </div>
                </div>
                <div class="row pt-3">
                    <div class="col-sm-12">
                        <div class="grant-button">
                            <a href="https://natural-resources.canada.ca/energy-efficiency/homes/canada-greener-homes-initiative/canada-greener-homes-grant/24833" class="text-center">Click here for more details.</a>
                        </div>
                    </div>
                </div>
            </div>-->
        </div>
    </div>
</div>

<!--BOOK AND PHONE BAR-->
<div class="container-fluid pt-5">
    <div class="row phone-bar bg-blue">
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-sm-4 border-r pb-mobile-20">
                        <h3 class="text-uppercase text-center lh-20 fw-400 text-red">Office</h3>
                        <p class="text-center text-white">587.596.3040</p>
                    </div>
                    <div class="col-sm-4 d-flex justify-content-center border-r pb-mobile-20">
                        <div class="action-button verticle-center-text" routerLink="/contact" href="/contact">
                            <span>BOOK ONLINE</span>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <h3 class="text-uppercase text-center lh-20 fw-400 text-red">Dispatch</h3>
                        <p class="text-center text-white">780.964.3299</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--OTHER SERVICES-->
<div class="container-fluid reduced-padding pt-5">
    <div class="row">
        <div class="col-12">
            <h1 class="text-center text-uppercase">Other Services</h1>
        </div>
    </div>
    <div class="row pt-3">
        <div class="col-sm-4">
            <div class="card transparent-card">
                <div class="card-header d-flex justify-content-center">
                    <div class="i-circle">
                        <i class="text-red fa fa-solid fa-fire"></i>
                    </div>
                </div>
                <div class="card-body text-center">
                    <h2>Heating</h2>
                    <p class="pt-2">Since Edmonton is known for its cooler climate, our heating experts will help you maximize the comfort level of your home even through our sub-zero winters.<br><a rel="/heating" href="/heating" class="text-red">Read more.</a></p>
                </div>
            </div>
        </div>
        <div class="col-sm-4 mobile-pt">
            <div class="card transparent-card">
                <div class="card-header d-flex justify-content-center">
                    <div class="i-circle rounded-circle">
                        <i class="text-blue fa fa-solid fa-snowflake"></i>
                    </div>
                </div>
                <div class="card-body text-center">
                    <h2>Cooling</h2>
                    <p class="pt-2">Edmonton weather is changing and the need to have climate control through these hot summer months is a must. Our cooling experts will help you beat the heat.<br><a rel="/cooling" href="/cooling" class="text-blue">Read more.</a></p>
                </div>
            </div>
        </div>
        <div class="col-sm-4 mobile-pt">
            <div class="card transparent-card">
                <div class="card-header d-flex justify-content-center">
                    <div class="i-circle rounded-circle">
                        <i class="text-yellow fa fa-solid fa-faucet"></i>
                    </div>
                </div>
                <div class="card-body text-center">
                    <h2>Plumbing</h2>
                    <p class="pt-2">Not just HVAC? That's right! Whether you need a new hot water tank, a pipe repaired, or a drain cleared, our plumbing experts are ready to help.<br><a rel="/plumbing" href="/plumbing" class="text-yellow">Read more.</a></p>
                </div>
            </div>
        </div>
    </div>
</div>

<!--QUESTIONS-->
<div class="container-fluid pb-5 pt-5">
    <div class="container goal-bar bg-red">
        <div class="row">
            <div class="col-lg-4 d-flex justify-content-center pb-768">
                <img src="../../../assets/company-logos/icon-sprite-questionbubble-white.png">
            </div>
            <div class="col-lg-8 mobile-pt">
                <div class="accordion mt-2" id="accordionQuestions">
                    <div class="card card-red">
                        <div class="card-header" id="headingOne">
                          <h2 class="mb-0">
                            <button class="btn btn-block text-left collapsed text-white text-bold" type="button" data-toggle="collapse" data-target="#collapseOne">
                                What Is A Heat Pump, And How Does It Work?
                            </button>
                          </h2>
                        </div>
                        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionQuestions">
                          <div class="card-body text-white">
                            Heat pumps are a proven technology that have been used for decades, both in Canada and globally, to efficiently provide heating, cooling, and in some cases, hot water for buildings. In fact, it is likely that you interact with heat pump technology on a daily basis: refrigerators and air conditioners operate using the same principles and technology. This section presents the basics of how a heat pump works, and introduces different system types.
                          </div>
                        </div>
                      </div>
                      <div class="card card-red">
                        <div class="card-header" id="headingTwo">
                          <h2 class="mb-0">
                            <button class="btn btn-block text-left collapsed text-white text-bold" type="button" data-toggle="collapse" data-target="#collapseTwo">
                                How Does an Air Source Heat pump Work?
                            </button>
                          </h2>
                        </div>
                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionQuestions">
                          <div class="card-body">
                            <div class="video-div pt-3 d-flex justify-content-center">
                                <iframe width="560" height="315" src="https://www.youtube.com/embed/-wTRGbDY7Kk?si=Mra0Z_5_7TfP03PQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                            </div>
                            <p class="text-center text-white">Source: <a class="text-blue" href="https://www.youtube.com/watch?v=-wTRGbDY7Kk">https://www.youtube.com/watch?v=-wTRGbDY7Kk</a></p>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>